// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"328":"plotlysystem","496":"blueprint","787":"plotly"}[chunkId] || chunkId) + "." + {"328":"347abb93","424":"c1449588","481":"c0590020","496":"15080f2b","787":"d4c7c9e5","924":"55274e4f"}[chunkId] + ".chunk.js";
};